export default __webpack_public_path__ + "static/media/obudavisual.a7e3a33a.svg";